import { useContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RightPanelTabs } from "../../constants/Panels";
import { UserContext, VersionContext } from "../../Context";
import { changeRightPanelTab, setBoatStatusOpen } from "../../store/appSlice";
import { isDefaultVersion } from "../../utils/versioningUtils";
import { StoreState } from "../../store/rootReducer";

import BriefcaseIcon from "../../assets/jobs/briefcase.svg?react";
import ImportIcon from "../../assets/import.svg?react";
import VrHeadsetIcon from "../../assets/vr-headset.svg?react";
import MapExport from "../../assets/map-export.svg?react";
import WarningIcon from "../../assets/warning-outline.svg?react";
import BoatIcon from "../../assets/boat-small.svg?react";
import BugIcon from "../ErrorReporter/BugIcon";
import "./HeaderMenu.css";
import { AppDispatch } from "../../store/storeSetup";
import { AppConfig } from "../../AppConfig";
import { hasAccessToGroups } from "../../utils/helpers";

interface RightHeaderMenuProps {
    onClose: () => void;
    onOpenErrorReporter: () => void;
}
const RightHeaderMenu = ({ onClose, onOpenErrorReporter }: RightHeaderMenuProps) => {
    const dispatch = useDispatch<AppDispatch>();

    const versionInfo = useSelector((state: StoreState) => state.version.versionInfo);
    const versionContext = useContext(VersionContext);
    const versionServiceRef = versionContext?.versionServiceRef.value;

    const userContext = useContext(UserContext);
    const userSelf = userContext?.userSelf.value;
    const hasAccessToBoatStatus = hasAccessToGroups(userSelf, [AppConfig.GroupAccess.BoatStatus]);

    const openEFSManager = () => {
        dispatch(changeRightPanelTab(RightPanelTabs.EFS_MANAGER));
        onClose();
    };

    const openMorildExport = () => {
        dispatch(changeRightPanelTab(RightPanelTabs.MORILD_EXPORT));
        onClose();
    };

    const openJobs = () => {
        dispatch(changeRightPanelTab(RightPanelTabs.JOBS));
        onClose();
    };

    const openDataImport = () => {
        dispatch(changeRightPanelTab(RightPanelTabs.DATA_IMPORT));
        onClose();
    };

    const openSksdLog = () => {
        dispatch(changeRightPanelTab(RightPanelTabs.SKSD));
        onClose();
    };

    const openBoatStatus = () => {
        dispatch(setBoatStatusOpen(true));
        onClose();
    };

    return (
        <div className="header-menu-container">
            {versionServiceRef?.current && isDefaultVersion(versionInfo, versionServiceRef?.current) && (
                <button className="header-menu-button" onClick={openEFSManager}>
                    <WarningIcon style={{ width: "22px", height: "22px" }} />
                    <span>EFS verktøy</span>
                </button>
            )}
            <button className="header-menu-button" onClick={openMorildExport}>
                <VrHeadsetIcon style={{ width: "22px", height: "22px" }} />
                <span>Morild export</span>
            </button>
            <button className="header-menu-button" onClick={openJobs}>
                <BriefcaseIcon style={{ width: "22px", height: "22px" }} />
                <span>Jobber</span>
            </button>
            <button className="header-menu-button" onClick={openDataImport}>
                <ImportIcon style={{ width: "22px", height: "22px" }} />
                <span>Dataimport</span>
            </button>
            <button className="header-menu-button" onClick={openSksdLog}>
                <MapExport style={{ width: "22px", height: "22px" }} />
                <span>SKSD Logg</span>
            </button>
            {hasAccessToBoatStatus && (
                <button className="header-menu-button" onClick={openBoatStatus}>
                    <BoatIcon style={{ width: "22px", height: "22px" }} />
                    <span>Båtstatus</span>
                </button>
            )}
            <button
                className="header-menu-button"
                onClick={() => {
                    onOpenErrorReporter();
                    onClose();
                }}
            >
                <BugIcon />
                <span>Rapporter feil</span>
            </button>
        </div>
    );
};

export default RightHeaderMenu;
